import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import { getAccountOptions } from '@lib/api/options/auth';
import {
  acceptLegalOptions,
  legalKey,
  legalStatusOptions,
} from '@lib/api/options/legal';
import { MutationCallbackOptions } from '@lib/api/options/types';
import { LegalState } from '@lib/types/legal';
import { getRateLimitMessage } from '@lib/utils/error-handler';

export const useAcceptLegal = (accountId: string) => {
  const client = useQueryClient();
  const { message } = App.useApp();
  const { mutateAsync: onAcceptLegal, isPending: accepting } =
    useMutation(acceptLegalOptions());

  const handleOnAcceptLegal = (
    revisionId: string,
    callbacks?: MutationCallbackOptions<LegalState>,
  ) =>
    onAcceptLegal(revisionId, {
      onSuccess: async (state) => {
        client.setQueryData(legalStatusOptions(accountId).queryKey, state);
        await client.invalidateQueries({
          queryKey: getAccountOptions().queryKey,
        });
        try {
          window.localStorage.setItem('nexo:legal-update', String(Date.now()));
        } catch {
          /* O refetch ao focar a aba mantém a sincronização quando o armazenamento está indisponível. */
        }

        message.success('Aceite dos Termos de Uso registrado.');
        callbacks?.onCompleted?.(state);
      },
      onError: (error) => {
        message.error(
          getRateLimitMessage(error) ??
            'Não foi possível registrar o aceite. Confira a revisão atual e tente novamente.',
        );
        client.invalidateQueries({ queryKey: legalKey }).catch(() => undefined);
        callbacks?.onError?.(error);
      },
    });

  return { acceptLegal: handleOnAcceptLegal, accepting };
};
